import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../NotificationDrawer.module.scss';
import cx from 'classnames';
export const ExpiredOrderDetails = ({ getOrderTitle }) => {
    return (_jsx("span", { className: cx(styles['expired-order-details__text'], `u-color--Medium Black`), "data-testid": "header-notification-title", children: getOrderTitle(true) }));
};
